import {createComponent, Config, DateTime, SelectField, t} from "@intermesh/goui";

export class MonthCombo extends SelectField {
	constructor() {
		super();

		const months = Object.values(t("full_months")) as string[];

		this.options = months.map((name, idx) => ({
			value: idx + 1,
			name: name.charAt(0).toUpperCase() + name.slice(1)
		}));

		this.value = (new DateTime()).getMonth();
	}
}

export const monthcombo = (config?: Config<SelectField>) => createComponent(new MonthCombo(), config);